<!--
  Landingpage „Warenautomat“ (Non-Food). Winkel: Handgemachtes/Kunsthandwerk/
  Geschenke 24/7 unbeaufsichtigt + Abschnitt „individuell/nach Maß“. Referenz:
  Geschenkeladen Ambiente Burgau (Live + Video).
-->
<section class="lp-hero">
  <div class="content content--wide lp-hero__grid">
    <div class="lp-hero__text reveal">
      <div class="lp-hero__orb" aria-hidden="true">🎁</div>
      <span class="lp-eyebrow" i18n="@@waren.hero.eyebrow">Non-Food · Handgemachtes · 24/7</span>
      <h1 class="title display" i18n="@@waren.hero.h1">Warenautomat für Non-Food</h1>
      <div class="line"></div>
      <p class="lp-lead" i18n="@@waren.hero.lead">
        Verkaufe Kunsthandwerk, Keramik, Geschenke und Souvenirs rund um die Uhr – unbeaufsichtigt und
        auch außerhalb der Öffnungszeiten. Die <span class="tm">marktbox</span> ist dein Warenautomat für
        deine Leidenschaft.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@waren.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="lp-cta__ghost" href="#einsatz" (click)="scrollTo($event, 'einsatz')" i18n="@@waren.hero.ctaAnchor">Wofür geeignet? ↓</a>
      </div>
    </div>
    <figure class="lp-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="marktbox Warenautomat für Non-Food-Artikel und Geschenke" i18n-alt="@@waren.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lp-hero__badge" i18n="@@waren.hero.badge">🛍️ 24/7 unbeaufsichtigt</span>
    </figure>
  </div>
</section>

<!-- ===== Einsatzbereiche ===== -->
<section id="einsatz" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@waren.use.h2">Für alles, was nicht gekühlt werden muss</h2>
    <p class="lp-intro reveal" i18n="@@waren.use.intro">
      Weil nichts verderben kann, ist der Warenautomat der vielseitigste Einsatz der marktbox – ideal
      für Kunsthandwerk, Manufakturen und den Einzelhandel.
    </p>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">🏺</span>
        <h3 i18n="@@waren.card1.h3">Kunsthandwerk &amp; Keramik</h3>
        <p i18n="@@waren.card1.p">Töpfereien, Künstler:innen und Manufakturen verkaufen ihre Werke rund um die Uhr.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🎁</span>
        <h3 i18n="@@waren.card2.h3">Geschenke &amp; Souvenirs</h3>
        <p i18n="@@waren.card2.p">Auch kurzfristig: Wer abends ein Geschenk braucht, wird am Automaten fündig.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🧼</span>
        <h3 i18n="@@waren.card3.h3">Manufaktur-Produkte</h3>
        <p i18n="@@waren.card3.p">Schmuck, Kunst, Deko, Bücher, Merch – alles Nicht-Verderbliche findet Platz.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🔒</span>
        <h3 i18n="@@waren.card4.h3">Sicher verwahrt</h3>
        <p i18n="@@waren.card4.p">Abschließbare Klappen schützen auch hochwertige oder zerbrechliche Ware.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Video: Ambiente Burgau (Facade) ===== -->
<section class="lp-section">
  <div class="content content--wide lp-media-grid">
    <div class="lp-video__text reveal">
      <span class="lp-eyebrow" i18n="@@waren.video.eyebrow">Aus der Praxis · Geschenkeladen</span>
      <h2 class="lp-h2" i18n="@@waren.video.h2">24/7-Geschenke aus dem Automaten</h2>
      <p class="lp-lead" i18n="@@waren.video.lead">
        Der Geschenkeladen Ambiente in Burgau nutzt eine individuell gestaltete marktbox, um seine
        Geschenkideen auch außerhalb der Öffnungszeiten anzubieten. Im Video zeigt die Inhaberin, wie das
        den Laden ergänzt.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@waren.video.cta">Automat konfigurieren</a>
      </div>
    </div>
    <div class="lp-video reveal">
      @if (!videoOpen) {
      <button type="button" class="lp-video__facade" [style.background-image]="'url(' + videoThumb + ')'"
        (click)="openVideo()" aria-label="Video abspielen: Geschenkeladen Ambiente Burgau" i18n-aria-label="@@waren.video.aria">
        <span class="lp-video__play"></span>
      </button>
      } @else {
      <iframe [src]="videoUrl!" title="marktbox – Geschenkeladen Ambiente Burgau" i18n-title="@@waren.video.title"
        allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>
      }
    </div>
  </div>
</section>

<!-- ===== Individuell / nach Maß ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@waren.ind.h2">Auch individuell &amp; nach Maß</h2>
    <p class="lp-intro reveal" i18n="@@waren.ind.intro">
      Nicht jedes Sortiment passt in die Standard-Box – deshalb lässt sich die marktbox anpassen:
      Modellwahl mit 24 oder 39 Fächern, flexible Erweiterungen, passendes Zubehör und individuelle
      Lösungen wie bei unserem Geschenkeladen-Partner in Burgau. So wird der Warenautomat genau auf
      deine Produkte zugeschnitten.
    </p>
    <div class="lp-cta reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@waren.ind.cta">Individuelle Box anfragen</a>
    </div>
  </div>
</section>

<!-- ===== Live-Link: Ambiente ===== -->
<section class="lp-section">
  <div class="content content--wide lp-live__grid">
    <div class="lp-live__text reveal">
      <span class="lp-eyebrow" i18n="@@waren.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lp-h2" i18n="@@waren.live.h2">Sieh, welche Geschenke gerade da sind</h2>
      <p class="lp-lead" i18n="@@waren.live.lead">
        Jede marktbox hat ihren eigenen Live-Link – hier am Beispiel von Ambiente Geschenkideen.
        Kundschaft sieht in Echtzeit, was verfügbar ist.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@waren.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@waren.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@waren.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@waren.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Ambiente Geschenkideen: Echtzeit-Verfügbarkeit" i18n-title="@@waren.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@waren.live.cap">Live-Beispiel: Ambiente Geschenkideen</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@waren.price.h2">Warenautomat kaufen oder mieten</h2>
    <div class="lp-price-grid">
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@waren.price.buyLabel">Kaufen</span>
        <span class="lp-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@waren.price.buyText">Einmalige Investition – ideal, wenn der Automat dauerhaft zum Laden gehört.</p>
      </div>
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@waren.price.rentLabel">Mieten</span>
        <span class="lp-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@waren.price.rentText">Planbare Kosten – gut, um einen zusätzlichen 24/7-Kanal zu testen.</p>
      </div>
    </div>
    <div class="lp-cta lp-cta--center reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@waren.price.cta">Zum Shop – Warenautomat konfigurieren</a>
    </div>
    <p class="lp-fineprint reveal" i18n="@@waren.price.fine">
      Mehr dazu: <a [routerLink]="['/', links.blog, blogSlug]">Warenautomaten für Non-Food-Artikel</a>
    </p>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@waren.faq.h2">Häufige Fragen zum Warenautomat</h2>
    <div class="lp-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lp-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lp-section lp-section--muted lp-final reveal">
  <div class="content content--wide">
    <h2 class="lp-h2" i18n="@@waren.final.h2">Bereit für deinen Warenautomaten?</h2>
    <p class="lp-lead" i18n="@@waren.final.lead">Non-Food rund um die Uhr – vielseitig, sicher und individuell anpassbar.</p>
    <div class="lp-cta lp-cta--center">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@waren.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
